<template>
    <form ref="filterForm">
        <aside class="filter" v-if="brand == null">
            <price-filter
                        v-if="sum"
                        :sum="sum"
                        :price-from="priceFromText"
                        :price-to="priceToText"
                        @onPriceChanged="filterChanged"
            ></price-filter>

            <on-stock-sidebar :title="stockTitleText" @onStockChanged="filterChanged"></on-stock-sidebar>

            <category-sidebar
                v-if="categories"
                :categories="categories"
                :main-category="category"
                :title="categoryTitleText"
            >
            </category-sidebar>

            <brands-sidebar v-if="brands"
                            :brands="brands"
                            :title="brandTitleText"
                            :all-brands="brandAllText"
                            @onBrandChanged="filterChanged"
            ></brands-sidebar>

            <params-sidebar v-if="params"
                            :params="params"
                            :title="paramsTitleText"
                            :all-params="paramsAllText"
                            @onParamChanged="filterChanged"
            ></params-sidebar>

            <badges-sidebar v-if="badges"
                            :title="badgesTitleText"
                            :badges="badges"
                            :all-badges="badgesAllText"
                            @onBadgeChanged="filterChanged"
            ></badges-sidebar>
    </aside>

    <div class="listing">
            <subcategories :subcategories="subcategories" v-if="subcategories && brand==null"></subcategories>

            <div v-if="brand" class="mt-30 mb-10" >
                <h1 v-if="brand" class="title">{{ brand.name }}</h1>
                <div v-if="brand.description" v-html="brand.description"></div>
            </div>

            <sort-filter @onOrderChanged="filterChanged"></sort-filter>

            <!-- products listing grid layout -->
            <div class="product-listing-wrapper product-grid" id="layout-grid">
<!--                <div class="row" v-if="products.length > 0" v-html="products"></div>-->
                <div class="row" v-if="productsData && productsData.length > 0">
                    <div :class="{
                            'col-lg-3 col-md-6': brand !== null,
                            'col-lg-4 col-md-6': brand === null
                         }"
                         v-for="(product, key) in productsData"
                         :key="key"
                    >
                        <ThemeProduct :data="product"
                                  :text-stock="textStock"
                                  :text-not-stock="textNotStock"
                                  :text-curr="textCurr"
                        />
                    </div>
                </div>
            </div>

            <!-- products listing list layout -->
<!--            <div class="product-listing-wrapper product-list" id="layout-list" v-if="productsList.length > 0" v-html="productsList"></div>-->
            <div class="product-listing-wrapper product-list" id="layout-list" v-if="productsData && productsData.length > 0">
                <div class="item"
                     v-for="(product, key) in productsData"
                     :key="key"
                >
                    <ThemeProductRow :data="product"
                                  :text-stock="textStock"
                                  :text-not-stock="textNotStock"
                                  :text-curr="textCurr"
                    />
                </div>
            </div>
            <div v-if="pagination.length > 0" v-html="pagination"></div>
        </div>
    </form>
</template>

<script>
import {inject, onMounted, ref, watch} from 'vue'
import Subcategories from './partials/Subcategories.vue'
import CategorySidebar from '../../widgets/CategorySidebar.vue'
import PriceFilter from '../../filters/PriceFilter.vue'
import BrandsSidebar from '../../widgets/BrandsSidebar.vue'
import BadgesSidebar from '../../widgets/BadgesSidebar.vue'
import ParamsSidebar from '../../widgets/ParamsSidebar.vue'
import OnStockSidebar from '../../widgets/OnStockSidebar.vue'
import SortFilter from '../../filters/SortFilter.vue'
import { useToast } from 'vue-toastification'
import emitter from '../../../utils/emitter'
import axios from 'axios'
import {getFromCategoriesBy} from "../../../../functions";
import ThemeProduct from "./partials/ThemeProduct.vue";
import ThemeProductRow from "./partials/ThemeProductRow.vue";

export default{
    components: {
        ThemeProductRow,
        ThemeProduct,
        Subcategories,
        PriceFilter,
        CategorySidebar,
        BrandsSidebar,
        SortFilter,
        ParamsSidebar,
        OnStockSidebar,
        BadgesSidebar
    },

    props: {
        route: {required: true, type: String},
        subcategories: {type: Array},
        categories: {type: Array},
        brand: {type: Object, default: null },
        category: {type: Object},
        sum: {type: Object},
        brands: {type: Object},
        params: {type: Object},
        badges: {type: Object},
        categoryTitleText: {required: false, type: String},
        brandTitleText: {required: false, type: String},
        brandAllText: {required: false, type: String},
        stockTitleText: {required: false, type: String},
        paramsTitleText: {required: false, type: String},
        paramsAllText: {required: false, type: String},
        badgesTitleText: {required: false, type: String},
        badgesAllText: {required: false, type: String},
        priceFromText: {required: false, type: String,},
        priceToText: {required: false, type: String},
        textStock: {required: false, type: String},
        textNotStock: {required: false, type: String},
        textCurr: {required: false, type: String},
        gtmDataP: {required: false}
    },

    setup(props) {
        const products        = ref(''),
              productsList    = ref(''),
              productsData    = ref(null),
              pagination      = ref(''),
              filterForm      = ref(null),
              sortFilterForm  = ref(null),
              toast           = useToast();

        const gtmData = ref(props.gtmDataP.length ? JSON.parse(props.gtmDataP) : null)

        const emitter2 = inject('emitter')

        onMounted( () => {
            emitter.emit(
                'setValuesFromParameters',
                getParametersFromHash(window.location.hash.substring(1))
            )

            if ( window.location.hash && window.location.href.indexOf('kategoria') > -1 || window.location.href.indexOf('znacka') > -1 )
                startFilter();
            else
                filter(null, null);
        });

        function startFilter() { sendAjax(getParametersFromHash(window.location.hash.substring(1)));}

        function filter(data, page) { sendAjax(data, page); }

        function getParametersFromHash( hash ) {

                let pieces = hash.split('&'),
                    data = {},
                    i,
                    parts;

                // process each query pair
                for ( i = 0; i < pieces.length; i++ ) {
                    parts = pieces[i].split('=');
                    if ( parts.length < 2 ) {
                        parts.push('');
                    }
                    data[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
                }

                return data;
        }

       function setHashParam(hashParameterName, hashParameterValue) {

            // create dummy url
            let theURL = new URL('https://dummy.com')

            // copy current hash-parameters without the '#' AS search-parameters
            theURL.search = window.location.hash.substring(1)

            // set or update value with the searchParams-API
            theURL.searchParams.set( hashParameterName, hashParameterValue )

            // Write back as hashparameters
            window.location.hash = theURL.searchParams.toString()
        }

        function setHashForFiltering(formData) {

            let brands = []
            let badges = []
            let properties = []
            let onStock = []

            formData.forEach((value, key) => {
                if ( key === 'brands[]' ) brands.push(value)
                if ( key === 'badges[]' ) badges.push(value)
                if ( key.includes('properties') ) properties.push(value)
                if ( key === 'onStock[]' ) onStock.push(value)

                if ( key !== 'brands[]' && key !== 'badges[]' && !key.includes('properties') && key !== 'onStock[]'  )
                    setHashParam(key, value);
            });

            setHashParam('brands', JSON.stringify(brands))
            setHashParam('badges', JSON.stringify(badges))
            setHashParam('properties', JSON.stringify(properties))
            setHashParam('onStock', JSON.stringify(onStock))
        }

        function filterChanged(page) {
            let formData = new FormData(filterForm.value)

            if(props.brand == null) setHashForFiltering(formData)
            else { // pre znacky nepotrebujeme ostatne filtre
                let orderValue = filterForm.value.order?.value || '';
                setHashParam('order', orderValue);
            }

            filter(formData, page)
        }

        function sendAjax(data, page = null) {

            emitter.emit('showLoader');

            if ( page !== null )
                data.append('page', page)

            axios.post(props.route, data)
                .then( response => {
                    products.value     = response.data.products;
                    productsList.value = response.data.productsList;
                    productsData.value = response.data.productsData;
                    pagination.value   = response.data.pagination;
                    emitter.emit('hideLoader');

                    setTimeout( () => {

                        document.querySelectorAll('.js-next-page').forEach( item => {
                            item.addEventListener('click', (e) => {
                                e.preventDefault();
                                let page = item.getAttribute('data-page');
                                setHashParam('page', page);
                                filterChanged(page);
                                scrollToTop(500);
                            })
                        })

                    }, 250)

                })
                .catch( response => toast.error('Vyskytla sa chyba :-(', { timeout: 2000 }) );
        }

        function scrollToTop (duration) {

            // cancel if already on top
            if ( document.scrollingElement.scrollTop === 0 ) return;

            const totalScrollDistance = document.scrollingElement.scrollTop;
            let scrollY = totalScrollDistance, oldTimestamp = null;

            function step (newTimestamp) {

                if ( oldTimestamp !== null ) {
                    // if duration is 0 scrollY will be -Infinity
                    scrollY -= totalScrollDistance * (newTimestamp - oldTimestamp) / duration;

                    if (scrollY <= 0) return document.scrollingElement.scrollTop = 0;

                    document.scrollingElement.scrollTop = scrollY;
                }

                oldTimestamp = newTimestamp;
                window.requestAnimationFrame(step);
            }
            window.requestAnimationFrame(step);
        }

        watch( () => productsData.value, (value, oldValue, onCleanup) => {
            // console.log(value, oldValue, onCleanup)

            if ( gtmData.value && value ) {
                value.forEach( (product, index) => {
                    gtmData.value.items.push({
                        'item_id': product.external_id,
                        'item_name': product.name,
                        'affiliation': 'Eshop',
                        'coupon': '',
                        'discount': '',
                        'index': index + 1,
                        'item_brand': product.brand ? product.brand.name : '',
                        'item_category': product.categories ? getFromCategoriesBy(1, product.categories) : '',
                        'item_category2': product.categories ? getFromCategoriesBy(2, product.categories) : '',
                        'item_category3': product.categories ? getFromCategoriesBy(3, product.categories) : '',
                        'item_category4': product.categories ? getFromCategoriesBy(4, product.categories) : '',
                        'item_category5': product.categories ? getFromCategoriesBy(5, product.categories) : '',
                        'item_list_id': '',
                        'item_list_name': '',
                        'item_variant': '',
                        'location_id': '',
                        'price': product.main_price_without_tax,
                        'quantity': 1
                    })
                })

                emitter2.emit('track-event', { data: gtmData.value, event: 'viewItemList' })
            }
        })

        return {
            products,
            productsList,
            productsData,
            pagination,
            filterForm,
            sortFilterForm,
            startFilter,
            filter,
            getParametersFromHash,
            setHashParam,
            filterChanged,
            setHashForFiltering,
            sendAjax,
            scrollToTop,
            toast
        }
    }
}
</script>
